module.exports = __webpack_public_path__ + "static/img/equipment-workshop_256.07fed5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment-workshop_256.png
// module id = M7HP
// module chunks = 0